import React, { useState } from 'react';
import './ImageZoom.css';

const ImageZoom = ({ src, width, height }) => {
  const [hovered, setHovered] = useState(false);
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);

  const handleMouseMove = e => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const { clientX, clientY } = e;
    const dx = (clientX - left) / width;
    const dy = (clientY - top) / height;
    setX(dx);
    setY(dy);
  };

  return (
    <div
      className="image-zoom-container"
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      <img
        className="image-zoom-image"
        src={src}
        alt=""
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onMouseMove={handleMouseMove}
        style={{
          transform: `scale(${hovered ? 2 : 1})`,
          transformOrigin: `${x * 100}% ${y * 100}%`,
        }}
      />
    </div>
  );
};

export default ImageZoom;
